import React from 'react';
import PropTypes from 'prop-types';
import ToggleButton from './ToggleButton';

// Блок «Раунды»: тумблеры описания/рейтинга слева + список раундов справа.
export default function RoundsColumn({ rounds, session, dispatch }) {
    const flags = session.flags || {};
    const currentRoundOrderId = session.currentRound?.orderId;

    return (
        <div className="ctrl-col rounds-col">
            <h4>Раунды</h4>
            <div className="rounds-inner">
                <div className="rounds-acts">
                    <ToggleButton
                        on={!!flags.roundDescriptionIsShow}
                        onLabel="Скрыть описание"
                        offLabel="Показать описание"
                        onClick={() => (flags.roundDescriptionIsShow ? dispatch.hideRoundDescription() : dispatch.showRoundDescription())}
                    />
                    <ToggleButton
                        on={!!flags.ratingIsShow}
                        onLabel="Скрыть рейтинг"
                        offLabel="Показать рейтинг"
                        onClick={() => (flags.ratingIsShow ? dispatch.hideRating() : dispatch.showRating())}
                    />
                </div>
                <div className="rounds-list">
                    {[...rounds].sort((a, b) => a.orderId - b.orderId).map(round => (
                        <button
                            type="button"
                            key={round.id}
                            className={`cbtn rbtn${round.orderId === currentRoundOrderId ? ' sel' : ''}`}
                            onClick={() => dispatch.selectRound(round.orderId)}
                        >
                            {round.orderId}. {round.title}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

RoundsColumn.propTypes = {
    rounds: PropTypes.array.isRequired,
    session: PropTypes.object.isRequired,
    dispatch: PropTypes.object.isRequired
};
